import React from "react";
import Modal from '../modal/Modal';
import { useHistory } from 'react-router-dom';
export var OfflinePreview = function OfflinePreview(props) {
  var addedToCart = props.addedToCart,
      _props$closeAddTo = props.closeAddTo,
      closeAddTo = _props$closeAddTo === void 0 ? function () {
    return "";
  } : _props$closeAddTo;
  var history = useHistory();

  var cartClick = function cartClick() {
    closeAddTo();
    history.push('/shop/cart');
  };

  var shoppingClick = function shoppingClick() {
    closeAddTo();
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: "cb-menu-secondary",
    show: addedToCart,
    hide: closeAddTo,
    exited: closeAddTo,
    title: "You've added an item to your cart!",
    titleSize: "sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__preview__lower"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "cb-button-secondary",
    id: "preview-keepshopping",
    onClick: shoppingClick
  }, "Keep Shopping"), /*#__PURE__*/React.createElement("a", {
    className: "cb-button-primary",
    id: "preview-keepshopping",
    onClick: cartClick
  }, "View Cart & Checkout"))));
};